<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import {EventBus, SHOW_PASSPORT_MODAL_EVENT} from '@/utils/event-bus'

    @Component
    export class PassportMixin extends Vue {
        createPassport(type, personId, language) {
            EventBus.$emit(SHOW_PASSPORT_MODAL_EVENT, {type, passport: null, personId, language})
        }

        editPassport(type, passport, personId) {
            EventBus.$emit(SHOW_PASSPORT_MODAL_EVENT, {type, passport, personId})
        }
    }

    export default PassportMixin
</script>
